import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion, Variants } from 'framer-motion';
import { cn } from '../lib/utils';
interface HyperTextProps {
  text: string;
  duration?: number;
  framerProps?: Variants;
  className?: string;
  animateOnLoad?: boolean;
}
const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const getRandomInt = (max: number) => Math.floor(Math.random() * max);
export function HyperText({
  text,
  duration = 800,
  framerProps = {
    initial: {
      opacity: 0,
      y: -10
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 3
    }
  },
  className,
  animateOnLoad = true
}: HyperTextProps) {
  const [displayText, setDisplayText] = useState(text.split(''));
  const [trigger, setTrigger] = useState(false);
  const interations = useRef(0);
  const isFirstRender = useRef(true);
  const triggerAnimation = () => {
    interations.current = 0;
    setTrigger(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (!animateOnLoad && isFirstRender.current) {
        clearInterval(interval);
        isFirstRender.current = false;
        return;
      }
      if (interations.current < text.length) {
        setDisplayText(t => t.map((l, i) => l === ' ' ? l : i <= interations.current ? text[i] : alphabets[getRandomInt(26)]));
        interations.current = interations.current + 0.1;
      } else {
        setTrigger(false);
        clearInterval(interval);
      }
    }, duration / (text.length * 10));
    return () => clearInterval(interval);
  }, [text, duration, trigger, animateOnLoad]);
  // Build word groups from the original text so we can wrap at word boundaries
  // (prevents single-line overflow on mobile)
  const words = text.split(' ');
  let runningIndex = 0;
  const wordGroups = words.map(word => {
    const startIndex = runningIndex;
    runningIndex += word.length + 1; // +1 for the space
    return {
      startIndex,
      length: word.length
    };
  });
  return <div className="flex flex-wrap justify-center gap-x-2 sm:gap-x-3 md:gap-x-4 cursor-default overflow-hidden py-1" onMouseEnter={triggerAnimation} data-id="element-147" data-mp="1a0v0045hsdzc">
      <AnimatePresence mode="wait" data-id="element-148" data-mp="103gjy5nhdr7k">
        {wordGroups.map((group, wi) => <div key={wi} className="flex flex-nowrap whitespace-nowrap" data-id="element-149" data-mp="mclj9gn4ygf2" data-mpi={wi}>
            {Array.from({
          length: group.length
        }).map((_, ci) => {
          const i = group.startIndex + ci;
          return <motion.span key={i} className={cn('font-mono font-bold text-lg sm:text-2xl md:text-3xl lg:text-4xl tracking-wide', className)} {...framerProps} data-id="element-150" data-mp="cdm89rewe8ow" data-mpi={ci}>
                  {(displayText[i] || '').toUpperCase()}
                </motion.span>;
        })}
          </div>)}
      </AnimatePresence>
    </div>;
}